export class MassEditItemModel {
  field = null
  command = null
  value = []
  // date = {
  //   year: null,
  //   month: null,
  //   day: null,
  //   hour: null,
  //   minute: null
  // }
}
